import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe za korekciju datuma prema vremenu (ako je vrijeme između 00:00 i 5:30 ujutro, datum se smanjuje za jedan dan).
 * Smanjuje se za jedan dan zato što se datum vožnje definira od 5:30 ujutro do sljedećeg dana u 5:30 ujutro
 */
@Pipe({
  name: 'correctedDate'
})
export class CorrectedDatePipe implements PipeTransform {

  /**
   * Vraća korigirani datum na temelju vremena.
   * @param value Datum ili string datuma.
   * @returns Korigirani datum.
   */
  transform(value: Date | string): Date {
    const date = new Date(value);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    if (hours < 5 || (hours === 5 && minutes < 30)) {
      date.setDate(date.getDate() - 1);
    }
    return date;
  }

}
